__turbopack_context__.v({
  "statCard": "StatCard-module__6e-wDG__statCard",
  "value": "StatCard-module__6e-wDG__value",
});
